
import React, { useState, useEffect, useMemo } from 'react';
import { TreeSelect } from 'primereact/treeselect';
import { Button } from 'primereact/button';

//import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';                       // core css
import 'primeicons/primeicons.css';                                 // icons
import 'primeflex/primeflex.css';
import { Controller, useFormContext } from 'react-hook-form';
import { FormHelperText, TextField } from '@mui/material';
import { classNames } from 'primereact/utils';
import './index.css';
import { I18NextNs } from 'enum/enum';
import { I18n } from 'utilities/utilities';
import { TreeNode } from 'primereact/treenode';

export const TreeSelectCustomItem = (props) => {

  const {
    id,
    name,
    required = false,
    IsShowMessageError = true,
    options,
    label,
  } = props;

  const { control } = useFormContext();

  const rules = useMemo(() => {
    return {
      required: {
        value: required,
        message: `${I18n.SetText("required", I18NextNs.validation)} ${label}`,
      },
    };
  }, [required, label]);

  const handleNodeSelect = (node: TreeNode) => {
    node.icon = "pi pi-fw pi-check-square";

    //set selectable
    if (node['nParentID']) {
      options.filter(f => f.id === node['nParentID']).forEach(m => { m.selectable = false; m.className = "disabled-text" });
    } else {
      node.children.forEach(m => { m.selectable = false; m.className = "disabled-text" });
    }
  }

  const handleChange = (event) => {
    if (event.value === null || event.value === undefined || event.value === "") {
      options.forEach(m => {
        m.icon = "pi pi-fw pi-stop";
        m.selectable = true;
        m.className = "";

        m.children.forEach(item => {
          item.icon = "pi pi-fw pi-stop";
          item.selectable = true;
          item.className = "";
        });
      });
    }
  }

  const handleNodeUnSelect = (node: TreeNode) => {
    node.icon = "pi pi-fw pi-stop";
    if (node['nParentID']) {
      options.filter(f => f.id === node['nParentID']).forEach(m => { m.selectable = true; m.className = "" });
    } else {
      node.children.forEach(m => { m.selectable = true; m.className = "" });
    }

  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      shouldUnregister={true}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { invalid, error },
      }) => (
        <>
          <span className="p-float-label">
            <TreeSelect
              id={id}
              key={name}
              value={value}
              onChange={(e) => {
                handleChange(e);
                onChange(e);
              }}
              inputRef={ref}
              display="chip"
              required={required}
              options={options}
              placeholder={props.placeholder}
              selectionMode="multiple"
              metaKeySelection={false}
              className={classNames('w-full', { 'p-invalid': error })}
              panelClassName={[...options].length > 0 ? "" : "empty-option"}
              emptyMessage="ไม่พบข้อมูล"
              onNodeSelect={(e) => handleNodeSelect(e.node)}
              onNodeUnselect={(e) => handleNodeUnSelect(e.node)}
            />
            <label htmlFor="description">{label} {required && <span style={{ color: "red" }}>*</span>}</label>
          </span>
          {IsShowMessageError && error ? (
            <FormHelperText>
              {error.message}
            </FormHelperText>
          ) : null}
        </>
      )}
    />
  );
}